import { HelmetProvider } from "react-helmet-async";
import App from "./App";

/**
 * Wrapper per App con HelmetProvider per SEO
 */
const AppWrapper = () => {
  return (
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
};

export default AppWrapper;
